import { EventEmitter } from "@angular/core";
import * as i0 from "@angular/core";
var GenericService = /** @class */ (function () {
    function GenericService() {
        this.onNewCalled = new EventEmitter();
        this.onEditCalled = new EventEmitter();
        this.onImportCalled = new EventEmitter();
        this.onDownloadTemplateCalled = new EventEmitter();
        this.onDownloadClaimCalled = new EventEmitter();
        this.onExportCalled = new EventEmitter();
        this.onSaveCalled = new EventEmitter();
        this.onDeleteCalled = new EventEmitter();
        this.onGoBackCalled = new EventEmitter();
        this.onOpenSetUnavailabilityCalled = new EventEmitter();
        this.onTableInfoChangeCalled = new EventEmitter();
        this.onAddAttachmentCalled = new EventEmitter();
    }
    GenericService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GenericService_Factory() { return new GenericService(); }, token: GenericService, providedIn: "root" });
    return GenericService;
}());
export { GenericService };
